module.exports = __webpack_public_path__ + "static/media/documentsIllustration.9dc05974.png";